// 9fbef606107a605d69c0edbcd8029e5d
import { PAYMENT_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const PAYMENT_CONSTANTS = {
  GET_CARD_LIST: `${PAYMENT_ACTION_PATTERN}GET_CARD_DETAILS`,
  SET_CARD_LIST: `${PAYMENT_ACTION_PATTERN}SET_CARD_DETAILS`,
  GET_ADDRESS_AND_CARD_LIST: `${PAYMENT_ACTION_PATTERN}GET_ADDRESS_AND_CARD_LIST`,
  GET_ADDRESS_AND_CARD_LIST_THROUGH_SPC: `${PAYMENT_ACTION_PATTERN}GET_ADDRESS_AND_CARD_LIST_THROUGH_SPC`,
  SET_GIFT_CARD_LIST: `${PAYMENT_ACTION_PATTERN}SET_GIFT_CARD_DETAILS`,
  GET_CARD_LIST_ERR: `${PAYMENT_ACTION_PATTERN}GET_CARD_DETAILS_ERROR`,
  SET_DEFAULT_PAYMENT: `${PAYMENT_ACTION_PATTERN}SET_DEFAULT_PAYMENT`,
  SET_DEFAULT_PAYMENT_SUCCESS: `${PAYMENT_ACTION_PATTERN}SET_DEFAULT_PAYMENT_SUCCESS`,
  SET_DEFAULT_PAYMENT_ERROR: `${PAYMENT_ACTION_PATTERN}SET_DEFAULT_PAYMENT_ERROR`,
  DELETE_MODAL_MOUNT_STATE: `${PAYMENT_ACTION_PATTERN}DELETE_MODAL_MOUNT_STATE`,
  DELETE_CARD: `${PAYMENT_ACTION_PATTERN}DELETE_CARD`,
  CLEAR_CARD_BALANCE: `${PAYMENT_ACTION_PATTERN}CLEAR_CARD_BALANCE`,
  UPDATE_CARD_LIST_ON_DELETE: `${PAYMENT_ACTION_PATTERN}UPDATE_CARD_LIST_ON_DELETE`,
  UPDATE_CARD_LIST_ON_DELETE_ERR: `${PAYMENT_ACTION_PATTERN}UPDATE_CARD_LIST_ON_DELETE_ERR`,
  CHECK_BALANCE: `${PAYMENT_ACTION_PATTERN}CHECK_BALANCE`,
  SET_CHECK_BALANCE: `${PAYMENT_ACTION_PATTERN}SET_CHECK_BALANCE`,
  SET_CHECK_BALANCE_ERROR: `${PAYMENT_ACTION_PATTERN}SET_CHECK_BALANCE_ERROR`,
  SET_LOADER: `${PAYMENT_ACTION_PATTERN}SET_LOADER`,
  SHOW_LOADER: `${PAYMENT_ACTION_PATTERN}SHOW_LOADER`,
  CREDIT_CARDS_PAYMETHODID: {
    'PLACE CARD': 'ADSPlaceCard',
    VISA: 'COMPASSVISA',
    AMEX: 'COMPASSAMEX',
    MC: 'COMPASSMASTERCARD',
    DISC: 'COMPASSDISCOVER',
    VENMO: 'VENMO',
  },
  GET_CARD_LIST_TTL: 0,
  ADD_GIFT_CARD_SUCCESS: `${PAYMENT_ACTION_PATTERN}ADD_GIFT_CARD_SUCCESS`,
  CLEAR_CARD_LIST_TTL: `${PAYMENT_ACTION_PATTERN}CLEAR_CARD_LIST_TTL`,
  CLEAR_GIFT_CARD_LIST_TTL: `${PAYMENT_ACTION_PATTERN}CLEAR_GIFT_CARD_LIST_TTL`,
  SET_PAYMENT_NOTIFICATION: `${PAYMENT_ACTION_PATTERN}SET_PAYMENT_NOTIFICATION`,
  FETCH_MODULEX_CONTENT: `${PAYMENT_ACTION_PATTERN}FETCH_MODULEX_CONTENT`,
  SET_MODULEX_CONTENT: `${PAYMENT_ACTION_PATTERN}ADD_MODULEX_CONTENT`,
};

export default PAYMENT_CONSTANTS;
